// extracted by mini-css-extract-plugin
export default {"likeButton":"bR-z","unLikedButton":"cR-z","likedButton":"dR-z"};